import type { Routes } from '@angular/router';

import { RoutePath, StatisticsType } from '@malou-io/package-utils';

import { restaurantStatisticsReadGuard } from '#core/guards/statistics-read.guard';
import { STATISTICS_PDF_ROUTES } from '#shell/routing/logged-in/restaurants/statistics-pdf/statistics-pdf.routing';
import { provideStatisticsScope } from '#shell/routing/logged-in/restaurants/statistics/statistics.provider';

export const STATISTICS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/statistics-layout/statistics-layout.component').then(
                (m) => m.StatisticsLayoutComponent
            ),
        providers: [provideStatisticsScope()],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'seo',
            },
            {
                path: 'roi',
                loadChildren: () => import('#modules/stats-roi/routes/roi.routes').then((m) => m.ROI_STATISTICS_ROUTES),
                data: { statisticsType: StatisticsType.ROI },
                canActivate: [restaurantStatisticsReadGuard],
            },
            {
                path: 'seo',
                loadChildren: () => import('#modules/statistics-seo/routes/seo-statistics.routes').then((m) => m.SEO_STATISTICS_ROUTES),
                data: { statisticsType: StatisticsType.SEO },
                canActivate: [restaurantStatisticsReadGuard],
            },
            {
                path: 'e-reputation',
                loadChildren: () =>
                    import('#modules/statistics-e-reputation/routes/e-reputation-statistics.routes').then(
                        (m) => m.E_REPUTATION_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.E_REPUTATION, routePath: RoutePath.E_REPUTATION_STATS },
                canActivate: [restaurantStatisticsReadGuard],
            },
            {
                path: 'social-networks',
                loadChildren: () =>
                    import('#modules/statistics-social-networks/routes/social-networks.routes').then(
                        (m) => m.SOCIAL_NETWORKS_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.SOCIAL },
                canActivate: [restaurantStatisticsReadGuard],
            },
            {
                path: 'totems',
                redirectTo: 'boosters',
            },
            {
                path: 'boosters',
                loadChildren: () =>
                    import('#modules/statistics-boosters/routes/boosters-statistics.routes').then((m) => m.BOOSTERS_STATISTICS_ROUTES),
                data: { statisticsType: StatisticsType.BOOSTERS },
                canActivate: [restaurantStatisticsReadGuard],
            },
            {
                path: 'download-pdf',
                loadChildren: () => STATISTICS_PDF_ROUTES,
            },
        ],
    },
];
